<header mat-dialog-title>
  <div class="dialog-header">
    <h2 class="mat-h2">{{ _meta.id === 0 ? 'Crear meta' : 'Editar meta ' + _meta.id}}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <h3 class="mat-h3">Áreas: <span style="font-weight: 400;">{{textoBusquedaAreas}}</span><span
      style="opacity: .32; margin: 0 8px;">|</span>Cursos: <span style="font-weight: 400;">{{textoBusquedaCursos}}</span></h3>
</header>
<mat-dialog-content>
  <meta-form [_meta]="_meta" [tiposMeta]="tiposMeta" [cursosOpt]="cursosOpt" [areas]="areas" [profesores]="profesores"
    [ambitos]="ambitos" [tags]="tags" [contexto]="contexto" [metaUnidadID]="metaUnidadID"
    (guardandoEvent)="guardandoActualizar($event)" (actualizar)="actualizar($event)"
    (cerrarDialog)="dialogRef.close(null)"></meta-form>
  <div class="cm-botones" *ngIf="guardando">
    <mat-progress-bar mode="query"></mat-progress-bar>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="cm-botones" *ngIf="!guardando">
    <button style="margin-right: 4px;" mat-button mat-dialog-close [disabled]="guardando"
      i18n="@@cancelar">Cancelar</button>
    <button mat-raised-button color="primary" (click)="guardar()" [disabled]="guardando"
      i18n="@@guardar">Guardar</button>
  </div>
</mat-dialog-actions>